import sreq from './_sreq';

const entries = [sreq];

export const getAllowedSettingsEntries = () => entries.filter(({ permissionChecker }) => permissionChecker());

export const hasAnyCommunitySettingsAccess = () => getAllowedSettingsEntries().length > 0;
